import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';
import { utils } from '../utils/index.js';

export type FabricCryptoStateOptions = {
  /**
   * '0': 状态关闭, '1': 标识 fabric_http.request 开启加密
   * @default '1'
   */
  state: '0' | '1';
};

export type FabricCryptoStateCallbackData = FabricCryptoStateOptions;

export type FabricHttpSetCryptoStateApi = (
  options: FabricCryptoStateOptions
) => boolean;

export type FabricHttpCheckCryptoStateApi = () => FabricCryptoStateCallbackData;

const hasFabricCryptoState = (type: 'setCryptoState' | 'checkCryptoState') => {
  return core.ntvHasMethod(`fabric_http.${type}`);
};

/**
 * 同步接口, 设置网络通道是否走全报文加密.
 * @returns boolean
 */
export const setCryptoState: FabricHttpSetCryptoStateApi = (options) => {
  // 当前native 不支持此方法.
  if (!hasFabricCryptoState('setCryptoState')) {
    utils.log.logData('No fabric_http.setCryptoState Support!');
    return false;
  }
  const result = core.call<
    'fabric_http.setCryptoState',
    FabricCryptoStateOptions,
    boolean
  >('fabric_http.setCryptoState', options);

  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};

/**
 * 同步接口, 获取网络通道是否走全报文加密的标识位, 注意如果Native检测到state==='0'(不加密), 默认state=1(走加密), 即便走加密, 也需要check header是否存在secId
 * 如果不存在secId, always也是不加密, 因为同一个APP 可能存在部分service 是不加密, 部分加密的情况.
 * 如果==='0'的时候native自己的业务请求直接移除header.secId,则不加密报文, 同时也自动移除fabric_http.request接口H5传递的header的secId.
 * FIXME: 此处存在安全隐患, 设置这个值的bridge 应该要经过授权才能调用, 避免泄漏导致问题.
 * @returns
 */
export const checkCryptoState: FabricHttpCheckCryptoStateApi = () => {
  // 当前native 不支持此方法.
  if (!hasFabricCryptoState('checkCryptoState')) {
    utils.log.logData('No fabric_http.checkCryptoState Support!');
    return {
      state: '0',
    };
  }

  const result = core.call<
    'fabric_http.checkCryptoState',
    null,
    FabricCryptoStateCallbackData
  >('fabric_http.checkCryptoState', null);

  const fabricErrors = filterFabricErrors(
    result.code,
    result.message,
    result.data
  );
  if (fabricErrors) {
    throw fabricErrors;
  } else {
    return result.data;
  }
};
